import React from 'react';
import { USER_ROLE } from '../../../../helpers/user/authorization';
import { FeatureContainer } from '../../../molecules/Containers/FeatureContainer';
import { ButtonWithText } from '../../../atoms/Buttons/ButtonWithText';
import useStyle from './classeContribution.style';
import useGoToPage from '../../../../hooks/useGoToPage';
import pages from '../../../../routes/pages';
import { ContainerFullWidth } from '../../../layouts/ContainerFullWidth';
import { TableInfoLegendary } from '../../../molecules/Table/TableInfoLegendary';
import { TableInfoContent } from '../../../molecules/Table/TableInfoContent';
import emoji from '../../../../theme/emoji';
import { IconButton } from '../../../atoms/Buttons/IconButton';
import { Modal } from '../../Modals/Modal';
import { ngoClassExplanation } from '../../../../domain/ngo/ngoTableExplanations';
import TableExplanations from '../TableExplanation';

export const ClassContribution = ({ studentsClass, contribution }) => {
  const classes = useStyle();
  const goToNgoChoice = useGoToPage(pages.NGO_CHOICE_PAGE.path, {
    type: 'classe'
  });
  return (
    <>
      {!studentsClass?.ngo && USER_ROLE === 'eleve' && (
        <FeatureContainer>
          <div className={classes.textButtonContainer}>
            <p>Aucune ONG classe séléctionnée pour le moment.</p>
          </div>
        </FeatureContainer>
      )}
      {!studentsClass?.ngo && USER_ROLE === 'professeur' && (
        <FeatureContainer>
          <div className={classes.textButtonContainer}>
            <p>Aucune ONG classe séléctionnée</p>
            <ButtonWithText
              variant="primaryBlue"
              content="Choix pour le don de la classe"
              onClick={goToNgoChoice}
            />
          </div>
        </FeatureContainer>
      )}
      {studentsClass?.ngo && (
        <ContainerFullWidth>
          <FeatureContainer>
            <div className={classes.header}>
              <div className={classes.title}>
                <h2>Résultats de la classe</h2>
                <img
                  className={classes.emoji}
                  src={emoji['BarChart'].url}
                  alt={emoji['BarChart'].alt}
                />
              </div>
              <Modal
                modalHead={'Comprendre ce tableau'}
                triggerButton={
                  <IconButton
                    icon="Info"
                    variant="backless"
                    onClick={() => null}
                  />
                }
              >
                <TableExplanations textExplanations={ngoClassExplanation} />
              </Modal>
            </div>
            <div className={classes.tableResult}>
              <TableInfoLegendary
                legends={[
                  'Taux d\'engagement "1 €" de nos clients (%)',
                  'Contributions "1 €"  de nos clients (€)',
                  'ONG choisie pour un don "classe"',
                  "Don de la classe = part de la Commission reversée à l'ONG (%)",
                  "Don de la classe = somme de la Commission reversée à l'ONG (€)",
                  'Total (1€ + don Classe + don France Challenges)'
                ]}
              />
              <TableInfoContent
                color="Blue"
                contents={[
                  `${contribution.studentsEngagement}%`,
                  `${contribution.numberOfOrdersWithCustomerContribution}€`,
                  `${contribution.ngoName}`,
                  `${contribution.percentOfCommissionDedicatedToNgo}%`,
                  `${contribution.total}€`,
                  `${contribution.totalDonatedToNgo.toFixed()}€`
                ]}
              />
            </div>
          </FeatureContainer>
        </ContainerFullWidth>
      )}
    </>
  );
};
